import search from './search';

export default {
  search,
};



// WEBPACK FOOTER //
// ./src/app/services/productUNCode/index.js